(function () {
  'use strict';
  if (window.igId39Installed) return;
  var template = document.getElementById('ig-id39-template');
  if (!template || (template.dataset.pageType !== 'page' && template.dataset.pageType !== 'product')) return;
  if (template.dataset.pageType === 'product' && !template.dataset.productHandle) return;
  window.igId39Installed = true;
  var active = false;
  var states = new Map();
  var scheduled = false;
  var containerSelector = '.product__info-container[data-product-handle], [data-ig-id39-container][data-product-handle]';

  function applyReviewValue(state, node, attribute, value, values) {
    if (!node) return;
    values = values || state.reviewCopy;
    var current = attribute ? node.getAttribute(attribute) : node.textContent;
    var saved = values.find(function (item) { return item.node === node && item.attribute === attribute; });
    if (!saved) {
      saved = { node: node, attribute: attribute, original: current, applied: null };
      values.push(saved);
    } else if (current !== saved.applied) saved.original = current;
    if (current !== value) {
      if (attribute) node.setAttribute(attribute, value); else node.textContent = value;
    }
    saved.applied = value;
  }

  function applyCustomReviewLabel(state, label, value) {
    var textNodes = [];
    function collect(node) {
      Array.prototype.forEach.call(node.childNodes, function (child) {
        if (child.nodeType === 3) textNodes.push(child);
        else collect(child);
      });
    }
    collect(label);
    var first = textNodes.find(function (node) { return node.textContent.trim(); }) || textNodes[0];
    textNodes.forEach(function (node) { applyReviewValue(state, node, null, node === first ? value : ''); });
  }

  function updateReviewCopy(state) {
    var rating = state.rating;
    var looxLabel = rating && rating.querySelector('.loox-rating-label');
    var label = looxLabel || (rating && rating.querySelector('[data-ig-id39-source-label]'));
    var pattern = template.dataset.reviewPattern;
    if (!label || !pattern) {
      if (state.cssMode) restoreReviewCopy(state);
      return;
    }
    var score = Number(rating.getAttribute('data-rating'));
    var count = Number(rating.getAttribute('data-raters'));
    if (!Number.isFinite(score) || score <= 0 || score > 5 || !Number.isInteger(count) || count < 0 || (!looxLabel && count === 0)) {
      if (state.cssMode) restoreReviewCopy(state);
      return;
    }
    var locale = template.dataset.reviewLocale || 'en';
    var text = pattern.replace('__RATING__', new Intl.NumberFormat(locale, { maximumFractionDigits: 2 }).format(score))
      .replace('__COUNT__', new Intl.NumberFormat(locale, { maximumFractionDigits: 0 }).format(count));
    if (state.cssMode) applyReviewValue(state, label, 'data-ig-id39-review-text', text);
    else if (looxLabel) applyReviewValue(state, label, null, '\u00a0' + text);
    else applyCustomReviewLabel(state, label, '\u00a0' + text);
    applyReviewValue(state, rating, 'title', text);
    applyReviewValue(state, rating, 'aria-label', text);
    if (!state.cssMode) rating.querySelectorAll('svg title').forEach(function (title) { applyReviewValue(state, title, null, text); });
  }

  function restoreReviewPosition(state) {
    if (state.review) state.review.removeAttribute('data-ig-id39-rating');
    if (state.reviewMarker && state.review && state.box.contains(state.reviewMarker) && state.box.contains(state.review)) state.reviewMarker.replaceWith(state.review);
    if (state.reviewMarker) state.reviewMarker.remove();
    state.reviewMarker = null;
  }

  function restoreValues(values) {
    values.forEach(function (saved) {
      var current = saved.attribute ? saved.node.getAttribute(saved.attribute) : saved.node.textContent;
      if (current !== saved.applied) return;
      if (!saved.attribute) saved.node.textContent = saved.original;
      else if (saved.original === null) saved.node.removeAttribute(saved.attribute);
      else saved.node.setAttribute(saved.attribute, saved.original);
    });
  }

  function restoreReviewCopy(state) {
    restoreValues(state.reviewCopy);
    state.reviewCopy = [];
  }

  function restore(state) {
    restoreReviewCopy(state);
    if (state.cssMode) {
      restoreValues(state.presentationCopy);
      state.presentationCopy = [];
      return;
    }
    if (state.badge) state.badge.remove();
    if (state.headingAnchor) state.headingAnchor.removeAttribute('data-ig-id39-title');
    restoreReviewPosition(state);
  }

  function syncCssContainer(state) {
    var box = state.box;
    var anchor = box.querySelector('[data-ig-id39-source-title]');
    var rating = box.querySelector('[data-ig-id39-source-rating]');
    var label = rating && (rating.querySelector('.loox-rating-label') || rating.querySelector('[data-ig-id39-source-label]'));
    if (state.headingAnchor !== anchor || state.rating !== rating || state.cssLabel !== label) restore(state);
    state.headingAnchor = anchor;
    state.rating = rating;
    state.cssLabel = label;
    if (!anchor) return;
    var badgeSource = template.content.querySelector('[data-id39-country]');
    var badgeText = badgeSource && badgeSource.textContent.trim();
    applyReviewValue(state, box, 'data-ig-id39-active', '', state.presentationCopy);
    applyReviewValue(state, anchor, 'data-ig-id39-title', '', state.presentationCopy);
    if (badgeText) applyReviewValue(state, anchor, 'data-ig-id39-badge-text', badgeText, state.presentationCopy);
    if (rating) applyReviewValue(state, rating, 'data-ig-id39-rating', '', state.presentationCopy);
    updateReviewCopy(state);
  }

  function syncContainer(state) {
    var box = state.box;
    var cssMode = box.getAttribute('data-ig-id39-presentation') === 'css';
    if (state.cssMode !== cssMode) {
      restore(state);
      state.badge = state.review = state.reviewMarker = state.headingAnchor = state.rating = state.cssLabel = null;
      state.cssMode = cssMode;
    }
    if (cssMode) {
      syncCssContainer(state);
      return;
    }
    var anchor = box.querySelector('[data-ig-id39-source-title]');
    if (!anchor) {
      anchor = box.querySelector('h1.pf-alt-title, .product__title h1');
      while (anchor && anchor.parentElement && anchor.parentElement !== box) anchor = anchor.parentElement;
    }
    if (state.headingAnchor && state.headingAnchor !== anchor) state.headingAnchor.removeAttribute('data-ig-id39-title');
    state.headingAnchor = anchor;
    if (anchor) anchor.setAttribute('data-ig-id39-title', '');
    else restoreReviewPosition(state);
    if (!state.badge || !box.contains(state.badge)) {
      if (state.badge) state.badge.remove();
      state.badge = template.content.firstElementChild.cloneNode(true);
    }
    if (anchor) {
      if (state.badge.nextElementSibling !== anchor) anchor.before(state.badge);
    } else if (box.firstElementChild !== state.badge) box.prepend(state.badge);
    var rating = box.querySelector('.loox-rating') || box.querySelector('[data-ig-id39-source-rating]') || box.querySelector('.hhlist-bbrating, .rating-stars');
    if (rating !== state.rating || (state.review && !box.contains(state.review))) {
      restoreReviewCopy(state);
      restoreReviewPosition(state);
      state.rating = rating;
      var wrapper = rating && (rating.closest('.shopify-app-block') || rating.closest('a[href="#looxReviewsFrame"]'));
      state.review = wrapper && box.contains(wrapper) ? wrapper : rating;
    }
    if (state.review && anchor && state.review !== anchor && !state.review.contains(anchor)) {
      if (!state.reviewMarker || !box.contains(state.reviewMarker)) {
        state.reviewMarker = document.createComment('ig-id39-rating-position');
        state.review.before(state.reviewMarker);
      }
      if (anchor.nextElementSibling !== state.review) anchor.after(state.review);
      state.review.setAttribute('data-ig-id39-rating', '');
    }
    updateReviewCopy(state);
  }

  function sync() {
    scheduled = false;
    if (!active) return;
    if (template.dataset.pageType === 'page' && typeof window.igId39PrepareLandings === 'function') window.igId39PrepareLandings();
    var candidates = Array.prototype.filter.call(document.querySelectorAll(containerSelector), function (box) {
      var handle = box.getAttribute('data-product-handle');
      return handle && (template.dataset.pageType === 'page' || handle === template.dataset.productHandle);
    });
    var boxes = new Set(candidates.filter(function (box) {
      return !candidates.some(function (other) { return other !== box && box.contains(other); });
    }));
    states.forEach(function (state, box) {
      if (!boxes.has(box)) {
        restore(state);
        states.delete(box);
      }
    });
    boxes.forEach(function (box) {
      if (!states.has(box)) states.set(box, { box: box, reviewCopy: [], presentationCopy: [] });
      syncContainer(states.get(box));
    });
  }

  function schedule() {
    if (!active || scheduled) return;
    scheduled = true;
    requestAnimationFrame(sync);
  }

  window.igId39ApplyVariant = function (variant) {
    active = variant === 'v1';
    if (active) sync();
    else {
      states.forEach(restore);
      states.clear();
    }
  };
  var observer = new MutationObserver(schedule);
  observer.observe(document.body, { childList: true, subtree: true, attributes: true, attributeFilter: ['data-rating', 'data-raters', 'data-product-handle'] });
  var choice = window.__ig39Variant || 'control';
  if (template.dataset.previewAllowed === 'true') {
    var requested = new URLSearchParams(window.location.search).getAll('cdxtest');
    if (requested.includes('39-v1')) choice = 'v1';
    if (requested.includes('39-control')) choice = 'control';
  }
  window.igId39ApplyVariant(choice);
})();
